import { createContext, FunctionComponent, PropsWithChildren, useCallback, useMemo, useState } from 'react';

export const ReloadContext = createContext<
  | {
      reloadPage: () => void;
      lastRender: number;
    }
  | undefined
>(undefined);

export const ReloadProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [lastRender, setLastRender] = useState(Date.now());

  const reloadPage = useCallback(() => {
    setLastRender((previous) => Math.max(Date.now(), previous + 1));
  }, []);

  const value = useMemo(() => ({ lastRender, reloadPage }), [lastRender, reloadPage]);

  return (
    <ReloadContext.Provider key={lastRender} value={value}>
      {children}
    </ReloadContext.Provider>
  );
};
